import { lazy, Suspense } from "react"
import ReactDOM from "react-dom/client"
import { ToastContainer } from "react-toastify"

import "./i18n"

import "./css/index.css"
import "react-toastify/dist/ReactToastify.css"

// One codebase, two builds: the surface is fixed at build time, so each build loads only its own app.
const Root =
  process.env.REACT_APP_SURFACE === "agent"
    ? lazy(() => import("./AgentRoot").then((m) => ({ default: m.AgentRoot })))
    : lazy(() => import("./AdminRoot").then((m) => ({ default: m.AdminRoot })))

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

root.render(
  <>
    <Suspense fallback={null}>
      <Root />
    </Suspense>
    <ToastContainer
      position="bottom-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      className="z-50"
    />
  </>
)
